import { API_ROUTES } from "src/Common/ApiRoutes";
import { GroupModel } from "src/Common/Models/Group/GroupModel";
import axiosInstance from "src/utils/axios/axiosInstance";

export const GetGroupApi = async (): Promise<GroupModel[]>=> {
    const response = await axiosInstance.get(API_ROUTES.GROUP);
    return response.data; 
};

